/**
 * Container for CMS rich text.
 *
 * Its whole job is to be the opt-in point for the flow-margin rule in
 * assets/styles/global/_base.scss — `data-flow="content"` is what gives the
 * paragraphs, headings and lists inside authored HTML their vertical rhythm.
 * That rule is opt-in rather than global, so rich text rendered *without* this
 * component (or without the attribute) comes out as an unspaced wall of text.
 *
 * Use it for multi-element rich text — anything that can contain more than one
 * block. A single authored field rendered into one `<p>`/`<h2>` has no sibling
 * pairs inside it and does not need this; give that element its own margin in
 * the component's own SCSS instead.
 */
export default function RichText({
  html,
  className,
  as: Tag = 'div',
  ...rest
}) {
  if (!html) return null;

  return (
    <Tag
      {...rest}
      className={className}
      data-flow="content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
